module.exports = __webpack_public_path__ + "a86ea6f68c826fcdd409bf5a1d275571.png";